(function() {
    'use strict';
    
a3_cabin_reports.factory('CCMSCrewPositionFactory', CCMSCrewPositionFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CCMSCrewPositionFactory
    * @description 
    *   Manage Report's CCMSCrewPositions.
    * @ngInject
    */
function CCMSCrewPositionFactory(GenericModalFactory) {

        /**
         * Initialiaze CCMSCrewPosition object 
         * @memberof CCMSCrewPositionFactory
         */
		function CCMSCrewPosition() {
			this.Id = null;
			this.CrewId = null;
			this.Initials = null;
			this.Name = null;
			this.Position = null;
			this.CCMS = null;
			this.IsManual = false;
            this.CrewComments = null;
            this.HasCrewComments = false;
            this.needsAdditionalFeedback = false;
            this.HasAdditionalFeedbackComments = false;
            this.AdditionalFeedbackId = null;
            this.FeedbackAuthorName = null;
            this.Route = null;
		}

		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}
        
        /**
         * Create a new CCMSCrewPosition object 
         * @memberof CCMSCrewPositionFactory
         * @returns {object} CCMSCrewPosition
         */			 
		function createNew() {
			return GenericModalFactory.createNew(CCMSCrewPosition)
		}

        /**
         * Extend given CCMSCrewPosition object 
         * @memberof CCMSCrewPositionFactory
         * @param {object} obj The CCMSCrewPosition object that will be extended
         * @returns {object} CCMSCrewPosition
         */   
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,CCMSCrewPosition)
		}

        /**
         * Delete CCMSCrewPosition object from given list
         * @memberof CCMSCrewPositionFactory
         * @param {object} obj The CCMSCrewPosition object that will be deleted
         * @returns {array} CCMSCrewPositions
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
		
        /**
         * Extend given CCMSCrewPosition object List 
         * @memberof CCMSCrewPositionFactory
         * @param {object} obj The CCMSCrewPosition object that will be extended
         * @returns {array} CCMSCrewPositions
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,CCMSCrewPosition)
		}

		return service;
	}

})();
